export default __webpack_public_path__ + "666ca350364118f714b26b62d20a3e93.png";